// Montants : toujours des centimes entiers, jamais de flottants.

/** Espace fine insécable (U+202F), séparateur des milliers en français. */
export const ESPACE_FINE = '\u202f'

export function formaterMontant(centimes: number, devise = 'EUR'): string {
  if (!Number.isSafeInteger(centimes)) {
    throw new TypeError(`Montant en centimes attendu (entier), reçu : ${centimes}`)
  }
  const signe = centimes < 0 ? '-' : ''
  const absolu = Math.abs(centimes)
  const euros = Math.floor(absolu / 100)
  const reste = String(absolu % 100).padStart(2, '0')
  const milliers = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, ESPACE_FINE)
  const symbole = devise === 'EUR' ? '€' : devise
  return `${signe}${milliers},${reste}${ESPACE_FINE}${symbole}`
}

/**
 * Lit une saisie en euros (« 1 234,56 », « 1234.5 », « -12,3 € ») et renvoie des centimes.
 * Null si la saisie n'est pas un montant ou a plus de deux décimales.
 */
export function analyserMontant(texte: string): number | null {
  const nettoye = texte.replace(/[\s\u00a0\u202f]/g, '').replace(/€$/, '')
  const m = /^(-?)(\d+)(?:[.,](\d{1,2}))?$/.exec(nettoye)
  if (!m) return null
  const centimes = Number(m[2]) * 100 + Number((m[3] ?? '').padEnd(2, '0'))
  if (!Number.isSafeInteger(centimes)) return null
  return m[1] ? -centimes : centimes
}

/**
 * Nombre rendu par une API, en unités : point décimal, deux décimales au plus, treize chiffres au
 * plus avant le point (9 999 999 999 999,99 donne encore un entier sûr en centimes).
 */
const NOMBRE_API = /^-?\d{1,13}(\.\d{1,2})?$/

/**
 * Centimes d'un montant rendu par une API, nombre JSON (-23.44) ou chaîne (« -23.44 »). Le nombre
 * est lu dans son écriture décimale (`String`), chiffre à chiffre : aucune multiplication de
 * flottant (19.99 × 100 ne tombe pas juste). Null si ce n'est pas un montant : NaN, infini,
 * exposant (1e21), trois décimales, virgule (« 12,30 »), espace, signe +, ni nombre ni chaîne.
 */
export function centimesDepuisNombre(v: number | string): number | null {
  let texte: string
  if (typeof v === 'number') {
    if (!Number.isFinite(v)) return null
    texte = String(v)
  } else if (typeof v === 'string') {
    texte = v
  } else {
    // JSON inattendu (null, booléen, objet) malgré le type.
    return null
  }
  if (!NOMBRE_API.test(texte)) return null
  const centimes = analyserMontant(texte)
  // « -0.00 » : zéro, sans signe.
  return centimes === 0 ? 0 : centimes
}
